import React from 'react';
import './body.css'
const BodyTxt = (props) => {
    return ( <>
     <p>
        {props.text}
    </p>
    </> );
}

export default BodyTxt;